import { render, staticRenderFns } from "./enrolled-companies.vue?vue&type=template&id=068633d3&"
import script from "./enrolled-companies.vue?vue&type=script&lang=js&"
export * from "./enrolled-companies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports